import React, { Fragment, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import AppManager from "../../../managers/AppManager";
import RouteManager from "../../../managers/RouteManager";
import {
    removeLoader,
    showLoader,
    showToast,
    TOAST_TYPE,
    INPUT_TYPE,
    DKIcon,
    DKIcons,
    DKListPicker,
    DKListPicker2,
    DKButton,
    DKSpinner,
    DKLabel,
    DKCalendar,
    DKLine,
    DKTooltipWrapper,
    showAlert,
    DKInput,
    INPUT_VIEW_DIRECTION
} from "deskera-ui-library";

import "../../../css/CalendarView.scss";
import "./TimesheetEntry.scss";
import * as moment from "moment";

import TimesheetService, { TIMESHEET_CONSTANTS } from "../TimesheetService";
import TimesheetUtils from "../TimesheetUtils";
import Utility from "../../../utility/Utility";
import { DATE_FORMAT, FULL_MONTHS, WEEK_DAYS, YEARS } from "../../../constants/Constant";
import {
    PAGE_VIEW,
    CALENDAR_VIEW,
    CALENDAR_VIEW_OPTIONS,
    ENTRY_MODE,
    ENTRY_STATUS
} from "../TimesheetConstants";

import ic_cells from "../../../assets/icons/white/ic_cells.png";
import ic_cells_white from "../../../assets/icons/white/ic_cells_white.png";
import ic_calendar from "../../../assets/icons/ic_calendar.png";
import ic_folder from "../../../assets/icons/ic_folder.svg";
import ic_dollar from "../../../assets/icons/ic_dollar.svg";
import ic_play from "../../../assets/icons/ic_play.svg";
import ic_add_circle from "../../../assets/icons/ic_add_circle.svg";
import ic_arrow_right from "../../../assets/icons/ic_arrow_right.svg";
import ic_arrow_right_white from "../../../assets/icons/ic_arrow_right_white.svg";
import ic_stop_circle from "../../../assets/icons/ic_stop_circle.svg";
import ic_stopwatch_circle from "../../../assets/icons/ic_stopwatch_white.svg";
import ic_stopwatch_app_circle from "../../../assets/icons/ic_stopwatch_app.svg";
import ic_close_white from "../../../assets/icons/ic_close_white.svg";
import ic_stop_red from "../../../assets/icons/ic_stop_red.png";
import ic_add_white from "../../../assets/icons/ic_add_white.png";

import ic_add_app from "../../../assets/icons/ic_add_circle_app.svg";

import DataGridHolderPayroll from "../../common/DataGridHolderPayroll";
import AddTimesheetEntry from "./AddTimesheetEntry";
import DayViewCalender from "../../common/DayViewCalendar";
import WeekViewCalendar from "../../common/WeekViewCalendar";
import DKDateTime from "../../common/DKDateTime";
import CountUpTimer from "../../common/CountupTimer";
import { TENANT, TenantService } from "../../../managers/TenantManagerService";
import { convertDateToJson, reverseTimezoneOffset } from "../../../managers/common/CommonUtil";
import MoreEntriesPopup from "./MoreEntriesPopup";
import { TableManger, TABLES, TABLE_DISPLAY_NAME } from "../../../managers/TableManger";
import { parseColumnConfig, parseVisibleColumnConfig } from "../../configs/config";
import PermissionUtils, { ACTION, MODULE } from "../../user-permissions/PermissionUtils";

function TimesheetEntry(props) {
    const history = useHistory();
    const { t } = useTranslation();
    const calendarRef = React.createRef();

    const [timesheetEntries, setTimesheetEntries] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [timesheetEntryData, setTimesheetEntryData] = useState({
        columnData: parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_TIMESHEET_ENTRY), TABLES.PEOPLE_TIMESHEET_ENTRY)),
        rowData: [],
        filter: [],
        originalData: []
    });
    const [fetchingDependencies, setFetchingDependencies] = useState(true);
    const [pageView, setPageView] = useState(PAGE_VIEW.CALENDAR);
    const [calendarView, setCalendarView] = useState(CALENDAR_VIEW.DAY);
    const [showYearOption, setShowYearOption] = useState(false);
    const [showCalendarViewOption, setShowCalendarViewOption] = useState(false);
    const [month, setMonth] = useState(new Date().getMonth());
    const [year, setYear] = useState(new Date().getFullYear());
    const [date, setDate] = useState(new Date().getDate());
    const [today] = useState(new Date());
    const [prevButtonTapped, setPrevButtonTapped] = useState(false);
    const [nextButtonTapped, setNextButtonTapped] = useState(false);
    const [todayTapped, setTodayTapped] = useState(false);
    const [refreshingView, setRefreshingView] = useState(false);

    const [entryMode, setEntryMode] = useState(ENTRY_MODE.TIMER);
    const [showInputTaskList, setShowInputTaskList] = useState(false);
    const [showTaskList, setShowTaskList] = useState(false);
    const [tasks, setTasks] = useState(null);
    const [customer, setCustomer] = useState(null);
    const [projectList, setProjectList] = useState(null);
    const [filteredTasks, setFilteredTasks] = useState(null);
    const [taskInputText, setTaskInputText] = useState("");
    const [selectedTask, setSelectedTask] = useState();
    const [isBillable, setIsBillable] = useState(false);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [entryDate, setEntryDate] = useState(new Date());
    const [showStartTimePicker, setShowStartTimePicker] = useState(false);
    const [startTime, setStartTime] = useState(new Date());
    const [showEndTimePicker, setShowEndTimePicker] = useState(false);
    const [endTime, setEndTime] = useState(new Date());

    const [timer, setTimer] = useState(0);
    const [startTimer, setStartTimer] = useState(false);
    const [stopTimer, setStopTimer] = useState(false);
    const [billableVisible,setBillableVisible] = useState(false);
    const initialFormState = {
        task: {
            id: "task",
            title: t("Task"),
            type: INPUT_TYPE.DROPDOWN,
            validation: [["required"]],
            readOnly:false,
            options: tasks?.map(e=>{ return {...e,label:e.name,value: e.id}}) || [],
            tooltip: "Tasks belong to customer and project as well as not below to any project"
        },
        customer: {
            id: "customer",
            title: t("Customer"),
            type: INPUT_TYPE.DROPDOWN,
            readOnly: false,
            options: customer?.map(e=>{ return {...e,label:e.name,value: e.id?.toString()}}) || [],
            tooltip: "You must have books access to fetch customer"

        },
        project: {
            id: "project",
            title: t("Project"),
            type: INPUT_TYPE.DROPDOWN,
            readOnly: false,
            options: projectList?.map(e=>{ return {...e,label:e.name,value: e.id}}) || [],
            tooltip: "Project which belong to customer that you select"
        },
    }
    const [formState, setFormState] = useState(initialFormState);

    useEffect(() => {
        RouteManager.setPresenter({ props: { ...props, history: history } });
        AppManager.scrollToTop();

        fetchDependencies();
    }, []);

    useEffect(() => {
        if (!fetchingDependencies) {
            setDraftTimesheetEntry();
        }
    }, [fetchingDependencies]);

    useEffect(() => {
        refreshView();
        setDraftTimesheetEntry();
    }, [calendarView, pageView, timesheetEntries]);

    const fetchDependencies = async () => {
        showLoader();

        const dependencies = [
            TimesheetService.getTasks(false).finally(()=>{
                setFetchingDependencies(false);
            }),
            TimesheetService.getProjects(false),
            TimesheetService.getCustomers(false).finally(()=>{
                removeLoader()
            }),
            TimesheetService.getTimesheetEntries(false)
        ];

        const results = await Promise.all(dependencies.map(p => p.catch(e => e)));
        const response = results.filter(result => !(result instanceof Error));
        const taskResponse = response[0];
        const projectResponse = response[1];
        const customerResponse = response[2];
        const timesheetEntriesResponse = response[3];

        if (Array.isArray(taskResponse?.data)) {
            const tasks = taskResponse.data.map((t) => {
                const task = {
                    ...t,
                    projectId: null,
                    customer: null,
                    projectName: null,
                    customerName: null
                };

                const project = TimesheetUtils.findProject(projectResponse?.data, t.projectId);
                if (project) {
                    task.projectId = project.id;
                    task.projectName = project.name;

                    const customer = TimesheetUtils.findCustomer(customerResponse, project.customer);
                    if (customer) {
                        task.customer = String(customer.id);
                        task.customerName = customer.name;
                    }
                }

                return task;
            });
            
            const newState = {...formState};
            newState['task'].options = tasks?.map(e=>{ return {...e,label:e.name,value: e.id}}) || [];
            newState['customer'].options = customerResponse?.map(e=>{ return {...e,label:e.name,value: e.id?.toString()}}) || []
            newState['project'].options = projectResponse?.data?.map(e=>{ return {...e,label:e.name,value: e.id?.toString()}}) || []
            
            setFormState(newState)
            setTasks(tasks);
            setFilteredTasks(tasks);
            setProjectList(projectResponse?.data)
            setCustomer(customerResponse)
        }

        if (Array.isArray(timesheetEntriesResponse?.data)) {
            setTimesheetEntries(timesheetEntriesResponse.data);
        }

        setFetchingDependencies(false);
        removeLoader();
    }

    const setDraftTimesheetEntry = () => {
        const draftEntry = timesheetEntries?.find((entry) => Utility.isEmpty(entry.toDate));
        if (draftEntry) {
            const timer = (new Date().getTime() - new Date(moment(draftEntry.fromDate)).getTime()) / 1000;
            setTimer(Math.floor(timer));
            setStartTimer(true);
            setTaskInputText(draftEntry.description);
            setIsBillable(draftEntry.isBillable);

            let task = TimesheetUtils.findTask(tasks, draftEntry.jobId);
            task['customerName'] = draftEntry.customerName;
            task['customer'] = draftEntry.customer;
            task['projectId'] = draftEntry.projectId;
            const projectOBJ = TimesheetUtils.findProject(projectList, task.projectId);
                if (projectOBJ) {
                    task['projectId'] = projectOBJ.id;
                    task['projectName'] = projectOBJ.name;

                    const customerOBJ = TimesheetUtils.findCustomer(customer, projectOBJ.customer);
                    if (customerOBJ) {
                        task['customer'] = String(customerOBJ.id);
                        task['customerName'] = customerOBJ.name;
                    }
                }
                const newState = {...formState};
            newState['customer'].value = task?.customerName;
            newState['project'].value = task?.projectName;
            newState['task'].value = task?.name;
            setFormState(newState);
            setSelectedTask(task);
        }
    }
    const getFunctionConfig = () => {
        let config = {
          "onSubmit": onSubmit,
          "onRowDelete": onRowDelete
        };
        return config;
      }
    const refreshView = () => {
        if (pageView === PAGE_VIEW.CALENDAR) {
            if (calendarView === CALENDAR_VIEW.MONTH) {
                renderCalendar(month, year);
            }
        } else {
            setRefreshingView(true);
            TimesheetService.getTimesheetEntries(true).then(
                (response) => {
                    if (Array.isArray(response?.data)) {
                        const functionConfig = getFunctionConfig()
                        const rowData = TimesheetUtils.getTimesheetEntryRowData(response.data, tasks, functionConfig);
                        setTimesheetEntryData({
                            ...timesheetEntryData,
                            rowData: rowData,
                            originalData: rowData,
                            columnData: parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_TIMESHEET_ENTRY), TABLES.PEOPLE_TIMESHEET_ENTRY)),
                        });
                        setTotalPageCount(response?.filterConfig?.totalPage);
                    } else {
                        setTimesheetEntryData({
                            ...timesheetEntryData,
                            rowData: [],
                            originalData: [],
                            columnData: parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_TIMESHEET_ENTRY), TABLES.PEOPLE_TIMESHEET_ENTRY)),
                        });
                    }
                    setRefreshingView(false);
                }, (error) => {
                    setTimesheetEntryData({
                        ...timesheetEntryData,
                        rowData: [],
                        originalData: [],
                        columnData: parseVisibleColumnConfig(parseColumnConfig(TableManger.getTableVisibleColumns(TABLES.PEOPLE_TIMESHEET_ENTRY), TABLES.PEOPLE_TIMESHEET_ENTRY)),
                    });
                    setRefreshingView(false);
                    showToast("Error while getting timesheet entry, Please try after sometime.", TOAST_TYPE.FAILURE);
                }
            );
        }
    }

    const getTimesheetEntries = () => {
        showLoader()
        setRefreshingView(true);
        TimesheetService.getTimesheetEntries(pageView === PAGE_VIEW.LIST).then(
            (response) => {
                removeLoader()
                if (Array.isArray(response?.data)) {
                    setTimesheetEntries(response.data);
                } else {
                    setTimesheetEntries([]);
                }
                setRefreshingView(false);
            }, (error) => {
                removeLoader()
                setRefreshingView(false);
                showToast("Error while getting timesheet entry, Please try after sometime.", TOAST_TYPE.FAILURE);
            }
        );
    }

    const onRowEdit = (data) => {
        if (data?.rowData) {
            if(isTimerStart() && Utility.isEmpty(data.rowData?.timesheetEntry?.toDate)) {
                showToast("Please stop timer to edit new Timesheet entry")
                return
            }
            if(data.rowData?.timesheetEntry?.status === ENTRY_STATUS.REJECTED && !TenantService.get(TENANT.IS_ADMIN)){
                return;
            }
            showAddTimesheetEntryPopup({
                isEdit: true,
                entryData: data.rowData.timesheetEntry,
                onSave: () => {
                    getTimesheetEntries();
                }
            });
        }
    }

    const onRowDelete = (data) => {
        let payload
        if (data?.rowData) {
            if (data.rowData.timesheetEntry.status === "APPROVED" || data.rowData.timesheetEntry.status === "REJECTED" || data.rowData.timesheetEntry.status === TIMESHEET_CONSTANTS.SUBMITTED) {
                showAlert("Info","Not allowed to delete admin approved/rejected timesheet entry.");
                return;
            }
            if(isTimerStart() && Utility.isEmpty(data.rowData?.timesheetEntry?.toDate)) {
                showToast("Please stop timer to delete draft Timesheet entry")
                return
            }
            payload = {
                ids: [`${data.rowData.timesheetEntry.id}`]
            };

            showLoader("Deleting timesheet entry... Please wait");
            TimesheetService.deleteTimesheetEntry(payload).then(
                (response) => {
                    removeLoader();
                    showToast("Deleted timesheet entry successfully.", TOAST_TYPE.SUCCESS);
                    refreshView();
                    getTimesheetEntries()
                }, (error) => {
                    removeLoader();
                    if (error?.message) {
                        showAlert("Error",error?.message);
                    } else {
                        showToast("Error while deleting timesheet entry, Please try after sometime.", TOAST_TYPE.FAILURE);
                    }
                }
            );
        } else if(data?.length !=0) {
            let isAllow = true;
            let isApprovedRejected = true;
            let ids = []
            data.forEach(d=>{
                if (d.timesheetEntry.status === "APPROVED" || d.timesheetEntry.status === "REJECTED") {
                    isApprovedRejected = false
                }
                if(isTimerStart() && Utility.isEmpty(d?.timesheetEntry?.toDate)) {
                    showToast("Please stop timer to delete draft Timesheet entry")
                    isAllow = false
                }
                ids.push(d?.timesheetEntry?.id)
            })
            if(!isAllow || !isApprovedRejected) {
                
                
                refreshView();
                getTimesheetEntries()
                if(!isApprovedRejected)  {
                    showAlert("Info","Not allowed to delete admin approved/rejected timesheet entry.")
                }
                return
            }
            payload = {
                ids: ids
            };
            showLoader("Deleting timesheet entry... Please wait");
            TimesheetService.deleteTimesheetEntry(payload).then(
                (response) => {
                    removeLoader();
                    showToast("Deleted timesheet entry successfully.", TOAST_TYPE.SUCCESS);
                    refreshView();
                    getTimesheetEntries()
                }, (error) => {
                    removeLoader();
                    if (error?.message) {
                        showAlert("Error",error?.message);
                    } else {
                        showToast("Error while deleting timesheet entry, Please try after sometime.", TOAST_TYPE.FAILURE);
                    }
                }
            );
        }
    }

    const getPayload = (status, fromDate, toDate) => {
        let payload;

        if (status === "SUBMITTED") {
            if (fromDate && toDate) {
                payload = {
                    employeeId: TenantService.get(TENANT.USER_ID),
                    fromDate: moment(fromDate).format(),
                    toDate: moment(toDate).format(),
                    customer: selectedTask.customer,
                    customerName: selectedTask.customerName,
                    projectId: selectedTask.projectId,
                    jobId: selectedTask.id,
                    description: selectedTask.name,
                    isSynchronous: false,
                    isBillable: isBillable,
                    status: status
                };
            } else {
                payload = timesheetEntries?.find((entry) => Utility.isEmpty(entry?.toDate));
                if (payload) {
                    payload.toDate = moment().format();
                    payload['customerName'] = selectedTask.customerName
                    payload.status = status;
                }
            }
        } else {
            payload = {
                employeeId: TenantService.get(TENANT.USER_ID),
                fromDate: fromDate ?  moment(new Date(fromDate)).format():(new Date()),
                toDate: toDate ? moment(new Date(toDate)).format():null,
                customer: selectedTask.customer,
                customerName: selectedTask.customerName,
                projectId: selectedTask.projectId,
                jobId: selectedTask.id,
                description: selectedTask.name,
                isSynchronous: false,
                isBillable: isBillable,
                status: status
            };
        }

        return payload;
    }

    const saveOrUpdateTimesheetEntry = (payload, isUpdate) => {
        showLoader()
        if (isUpdate) {
            TimesheetService.updateTimesheetEntry(payload).then(
                (response) => {
                    removeLoader()
                    showToast("Timesheet entry updated successfully.",TOAST_TYPE.SUCCESS);
                    getTimesheetEntries();
                    
                }, (error) => {
                    if (error?.message) {
                        showAlert("Error",error.message);
                    } else {
                        showToast("Error while updating timesheet entry, Please try after sometime.", TOAST_TYPE.FAILURE);
                    }
                    setStartTimer(false);
                    setStopTimer(true);
                    setTimer(0);
                    removeLoader()
                }
            );
        } else {
            TimesheetService.saveTimesheetEntry(payload).then(
                (response) => {
                    removeLoader()
                    showToast("Timesheet entry added successfully.",TOAST_TYPE.SUCCESS);
                    getTimesheetEntries();
                }, (error) => {
                    if (error?.message) {
                        showAlert("Error",error.message);
                    } else {
                        showToast("Error while adding timesheet entry, Please try after sometime.", TOAST_TYPE.FAILURE);
                    }
                    setStartTimer(false);
                    setStopTimer(true);
                    setTimer(0);
                    removeLoader()
                }
            );
        }
    }

    const addTimesheetEntry = (status, fromDate, toDate) => {
        const payload = getPayload(status, fromDate, toDate);
        if (status === "SUBMITTED") {
            if (fromDate && toDate) {
                saveOrUpdateTimesheetEntry(payload, false);
            } else {
                saveOrUpdateTimesheetEntry(payload, true);
            }
        } else {
            saveOrUpdateTimesheetEntry(payload, false);
        }
    }

    const nextMonth = () => {
        const currentMonth = (month + 1) % 12;
        const currentYear = month === 11 ? year + 1 : year;
        setMonth(currentMonth);
        setYear(currentYear);
        renderCalendar(currentMonth, currentYear);
    };

    const prevMonth = () => {
        const currentMonth = month === 0 ? 11 : month - 1;
        const currentYear = month === 0 ? year - 1 : year;
        setMonth(currentMonth);
        setYear(currentYear);
        renderCalendar(currentMonth, currentYear);
    };

    const filterTasks = (searchText) => {
        if (searchText && Array.isArray(tasks)) {
            const filteredTasks = tasks.filter((t) => {
                return t.name?.toLowerCase().startsWith(searchText?.toLowerCase())
                    || t.projectName?.toLowerCase().startsWith(searchText?.toLowerCase())
                    || t.customerName?.toLowerCase().startsWith(searchText?.toLowerCase());
            });
            setFilteredTasks([...filteredTasks]);
        } else {
            setFilteredTasks([...tasks]);
        }
    }

    const getEntryModeButtonIcon = () => {
        let icon;

        if (entryMode === ENTRY_MODE.TIMER) {
            if (startTimer) {
                icon = ic_stop_red;
            } else {
                icon = ic_stopwatch_app_circle;
            }
        } else {
            icon = ic_add_app;
        }

        return icon;
    }

    const getDateEntries = (date, month, year) => {
        return timesheetEntries?.filter((entry) => {
            const fromDate = reverseTimezoneOffset(entry.fromDate);
            return date === fromDate.getDate()
                && month === fromDate.getMonth()
                && year === fromDate.getFullYear();
        });
    }

    const showMoreEntriesPopup = (config) => {
        const div = document.createElement("div");
        div.className = "app-font";
        const elementId = "show-more-entries-popup";
        div.setAttribute("id", elementId);

        ReactDOM.render(
            <MoreEntriesPopup
                {...config}
                elementId={elementId}
            />,
            document.body.appendChild(div)
        );
    }

    const showEntryOnCalendar = (entries, cell) => {
        entries.forEach((entry) => {
            const div = document.createElement("div");

            div.addEventListener("click", (e) => {
                e.stopPropagation();
                if(isTimerStart() && Utility.isEmpty(entry?.toDate)) {
                    showToast("Please stop timer to edit new Timesheet entry")
                    return
                }
                showAddTimesheetEntryPopup({
                    isEdit: true,
                    entryData: entry,
                    onSave: () => {
                        getTimesheetEntries();
                    }
                });
            }, false);

            div.style["display"] = "flex";
            div.style["align-items"] = "center";
            div.style["padding-left"] = "3px";
            div.style["padding-right"] = "3px";
            div.style["font-size"] = "12px";
            div.style["margin-bottom"] = "4px";

            div.innerHTML = TimesheetUtils.monthTaskRenderer(entry);

            cell.appendChild(div);
        });
    }

    const showAddTimesheetEntryPopup = (config) => {

        const div = document.createElement("div");
        div.className = "app-font";
        const elementId = "add-timesheet-entry-popup";
        div.setAttribute("id", elementId);

        ReactDOM.render(
            <AddTimesheetEntry
                {...config}
                tasks={tasks}
                elementId={elementId}
            />,
            document.body.appendChild(div)
        );
    }

    const renderTaskOption = (task) => {
        return (
            <div className="d-flex">
                <span className="mr-m ellipsis" style={{ maxWidth: "125px", minWidth: "125px" }}>
                    {task.name}
                </span>
                {task.projectName && <span className="mr-m fw-b ellipsis" style={{ maxWidth: "125px", minWidth: "125px" }}>
                    &#9679;&nbsp;{task.projectName}
                </span>}
                {task.customerName && <span className="fw-b text-gray ellipsis" style={{ maxWidth: "125px", minWidth: "125px" }}>
                    &#9679;&nbsp;{task.customerName}
                </span>}
            </div>
        );
    }

    const renderTaskList = (style, isFromIcon) => {
        return (
            <DKListPicker2
                className="position-absolute border-m shadow-m parent-width z-index-3"
                style={style}
                data={isFromIcon ? tasks : filteredTasks}
                renderer={(index, task) => {
                    return renderTaskOption(task);
                }}
                onSelect={(index, task) => {
                    setTaskInputText(task.name);
                    setIsBillable(task.isBillable);
                    setSelectedTask(task);
                    setShowInputTaskList(false);
                    setShowTaskList(false);
                }}
                onClose={isFromIcon ? () => {
                    setShowTaskList(false);
                } : null}
            />
        );
    }

    const renderDatePicker = () => {
        return (
            <DKCalendar
                isDateRange={false}
                selectedDate={entryDate}
                className="position-absolute border-m shadow-m bg-white z-index-3 mt-s"
                style={{
                    right: 0
                }}
                onSelectDate={(date) => {
                    setEntryDate(date);
                    setShowDatePicker(false);
                }}
                onClose={() => {
                    setShowDatePicker(false);
                }}
            />
        );
    }

    const renderTimePicker = (title, time, setTime, showTimePicker) => {
        return (
            <div className="transparent-background">
                <div className="popup-window justify-content-center justify-content-start-mobile">
                    <DKLabel text={title} className="fw-m fs-m mb-m" />
                    <DKLine className="mb-m" />
                    <DKDateTime
                        is12Hour={true}
                        selectedDate={moment(time, "hh:mm A").format()}
                        hideCalendar={true}
                        hideFooterDateTime={true}
                        onSave={(date) => {
                            setTime(date);
                            showTimePicker(false);
                        }}
                        onClose={() => {
                            showTimePicker(false);
                        }}
                    />
                </div>
            </div>
        );
    }
    const isTimerStart =()=>{
        return entryMode === ENTRY_MODE.TIMER && startTimer
    }
    const hasError = (field, value) => {
        let error = {
            invalid: false,
            errorMessage: null
        };

        const validation = field.validation;

        if (validation && validation.length !== 0) {
            validation.forEach((validation) => {
                switch (validation[0]) {
                    case "required":
                        if (value === null || value === undefined || String(value).trim() === "") {
                            error.invalid = true;
                        }
                        break;
                    default:
                        error.invalid = false;
                        error.errorMessage = null;
                        break;
                }
            });
        }
        switch(field.id) {
            case "fromDate":
            case "toDate":
                if(field.invalid) {
                    error.invalid = true;
                    error.errorMessage = 'From time should not be less than To Time';
                } else {
                    error.invalid = false;
                    error.errorMessage = null;
                    break;
                }
                break;
            default :
                break;
        }

        return error;
    }

    const updateState = (stateName, field, value) => {
        const newState = { ...formState };
        newState[stateName] = { ...field, value: value, ...hasError(field, value) };
        updateValueAndValidity(stateName, newState);

        setFormState(newState);
    }
    const getDropdownValue = (v, o) => {
        let value = v;

        const index = o.findIndex(i => i.label === v);
        if (index !== -1) {
            value = o[index].value;
        }

        return value;
    }
    const getDropdownObj = (v, o) => {
        let value = v;

        const index = o.findIndex(i => i.label === v);
        if (index !== -1) {
            value = o[index];
        }

        return value;
    }
    const updateValueAndValidity = (stateName,state) => {
        switch (stateName) {
            case "task":
            case "jobId":
                const taskId = getDropdownValue(state.task.value, state.task.options);

                let customerProject = {}
                if (taskId) {
                    const task = TimesheetUtils.findTask(state.task.options, taskId);
                    if (task) {
                        setIsBillable(task.isBillable)
                        //Note: will use leter// if(Utility.isEmpty(state.customer.value)) {
                            customerProject={
                                customer: task.customer,
                                customerName: task.customerName
                            }
                            state.customer.value = task.customerName
                        // }
                        //Note: will use leter// if(Utility.isEmpty(state.project.value)) {
                            customerProject={
                                ...customerProject,
                                projectId: task.projectId,
                                projectName: task.projectName
                            }
                            state.project.value = task.projectName
                        // }
                    }
                }

                let taskObj = getDropdownObj(state.task.value, state.task.options);
                taskObj = {
                    ...taskObj,
                    ...selectedTask,
                    ...customerProject
                }
                
                setSelectedTask(taskObj)
                break;
            case 'customer':
                const customerObj = getDropdownObj(state.customer.value, state.customer.options);
                if (customerObj) {
                    state.project.options = projectList?.filter(p => p.customer == customerObj.id).map(e => { return { ...e, label: e.name, value: e.id } })
                    
                    state.project.readOnly = false;
                    state.project.value = null;
                    state.task.value = null;
                    setSelectedTask({
                        ...selectedTask,
                        customer: customerObj.value?.toString(),
                        customerName: customerObj.label
                    })
                }
                break;
            case 'project':
                const projectObj = getDropdownObj(state.project.value, state.project.options);
                if(projectObj) {
                    state.task.options = tasks?.filter(t => (t.projectId == projectObj.id || (Utility.isEmpty(t.projectId)))).map(e => { return { ...e, label: e.name, value: e.id } })
                    state.task.value = null;
                    state.task.readOnly = false;
                    setSelectedTask({
                        ...selectedTask,
                        projectId: projectObj.value,
                        projectName: projectObj.label
                    })
                }
                break;
        }
    }
    const isRequired = (validation) => {
        return validation ? validation.findIndex((v) => v[0] === "required") !== -1 : false;
    }
    const renderField = (stateName, field, width, className) => {
        switch (field.type) {
            case INPUT_TYPE.TEXT:
            case INPUT_TYPE.NUMBER:
            case INPUT_TYPE.DATE:
                return (
                    <div key={field.id} style={{ flex: `${width}`, maxWidth: width }}>
                        <div className={`row position-relative ${!className ? "pr-l mb-s" : className}`}>
                            <DKInput
                                ref={field.ref}
                                title={field.title}
                                type={field.type}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                value={field.value}
                                errorMessage={field.errorMessage}
                                readOnly={!!field.readOnly || fetchingDependencies}
                                required={isRequired(field.validation)}
                                tooltip={{
                                    content: field.tooltip,
                                    className: "warning-tooltip-prop"
                                }}
                                invalid={field.invalid}
                                canValidate={field.invalid}
                                onChange={(value) => {
                                    updateState(stateName, field, value);
                                }}
                                validator={field.validator}
                            />
                        </div>
                    </div>
                );
            case INPUT_TYPE.DROPDOWN:
                return (
                    <div key={field.id} style={{ flex: `${width}`, maxWidth: width }}>
                        <div className={`row position-relative ${!className ? "pr-l mb-s" : className}`}>
                            <DKInput
                                title={field.title}
                                className="list-bottom field-invert-color text-white"
                                type={INPUT_TYPE.DROPDOWN}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                dropdownConfig={{
                                    allowSearch:true,
                                    searchableKey: "label",
                                    data: field.options,
                                    renderer: (i, item) => {
                                        if(stateName == 'task') {
                                           return <DKLabel className="text-app" text={item.projectName ? item.label+" ("+item.projectName+")" : item.label}/>
                                        }
                                        
                                        return <DKLabel className="text-app" text={item.label}/>
                                    },
                                    onSelect: (i, value) => {
                                        updateState(stateName, field, value.label);
                                    }
                                }}
                                value={field.value}
                                errorMessage={field.errorMessage}
                                readOnly={!!field.readOnly || fetchingDependencies}
                                required={isRequired(field.validation)}
                                invalid={field.invalid}
                                canValidate={field.invalid}
                                tooltip={{
                                    content: field.tooltip,
                                    className: "warning-tooltip-prop"
                                }}
                                onChange={() => { }}
                            />
                            <DKIcon className="ic-s clear-btn cursor-hand" src={ic_close_white} onClick={()=>clearSelection(field)}/>
                        </div>
                    </div>
                );
            case INPUT_TYPE.MULTI_SELECT:
                return (
                    <div key={field.id} style={{ flex: `${width}`, maxWidth: width }}>
                        <div className={`row position-relative ${!className ? "pr-l mb-s" : className} ${field.readOnly && "opacity-5"}`}>
                            <DKInput
                                title={field.title}
                                type={INPUT_TYPE.DROPDOWN}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                dropdownConfig={{
                                    multiSelect: true,
                                    checkMarkColor: "bg-app",
                                    allowSearch: field.options?.length > 6,
                                    searchableKey: "label",
                                    data: field.options,
                                    renderer: (i, item) => item.label,
                                    onSelect: (i, value) => { },
                                }}
                                displayKey={"label"}
                                value={field.value}
                                errorMessage={field.errorMessage}
                                readOnly={!!field.readOnly || fetchingDependencies}
                                required={isRequired(field.validation)}
                                invalid={field.invalid}
                                canValidate={field.invalid}
                                tooltip={{
                                    content: field.tooltip,
                                    className: "warning-tooltip-prop"
                                }}
                                onChange={(value) => {
                                    updateState(stateName, field, value);
                                }}
                            />
                        </div>
                    </div>
                );
            
            default:
                break;
        }
    }
    const clearSelection = (field) => {
        const newState = { ...formState };
        if(field) {
            newState[field.id].value = ""
            newState[field.id].invalid = false;
            switch(field.id) {
                case "customer":
                    newState['project'].value = '';
                    newState['project'].options = projectList?.map(e=>{ return {...e,label:e.name,value: e.id}}) || [];
                    newState['task'].value = ''
                    newState['task'].options = tasks?.map(e=>{ return {...e,label:e.name,value: e.id}}) || [];
                    break;

                case "project":
                    newState['task'].value = ''
                    newState['task'].options = tasks?.map(e=>{ return {...e,label:e.name,value: e.id}}) || [];
                    break;
            }
        } else {
            newState['customer'].value = ''
            newState['customer'].invalid = false
            newState['project'].value = '';
            newState['project'].options = projectList?.map(e=>{ return {...e,label:e.name,value: e.id}}) || [];
            newState['task'].value = ''
            newState['task'].invalid = false;
            newState['task'].options = tasks?.map(e=>{ return {...e,label:e.name,value: e.id}}) || [];
            setSelectedTask(null);
        }
        
        setFormState(newState);
        
    }
    const renderTimesheetEntryRow = () => {
        return (
            <div className="row align-items-center parent-width mb-l bg-app p-v-xs p-h-m border-radius-m border-m" style={{minHeight:125}}>
                <div className={`position-relative  web-width-50 ${isTimerStart() ? "pointer-events-none":""} `}>
                    
                    <div className="d-flex row-responsive web-width-90">
                        {renderField("customer", formState.customer, "90%")}
                        {renderField("project", formState.project, "90%")}
                        {renderField("task", formState.task, "90%")}
                        <div className="m-auto filter-btn-invert"> 
                            <DKTooltipWrapper
                                content={'Clear All'}
                                style={{ height: 'fit-content' }}
                                gapFromCursorY={20}
                                tooltipClassName="warning-tooltip-prop warning-tooltip-prop tooltip-top">
                                    
                                <DKButton  className={'mt-l text-white filter-btn-invert'} title={''} icon={ic_close_white} onClick={() => {
                                    clearSelection()
                                }} />
                                
                            </DKTooltipWrapper>
                        </div>
                        <div className="m-auto filter-btn">
                        <DKButton  className={'mt-l text-white border-m filter-btn'} title={'Clear All'} icon={ic_close_white} onClick={() => {
                                    clearSelection()
                                }} />
                        </div>
                        
                    </div>
                </div>
                <div className="ml-auto d-flex align-items-center" style={{gap:'1.5vw'}}>
                    
                    {billableVisible&&<div className={`mr-m ${isBillable && "border-radius-m bg-light-app"} ${isTimerStart() ? "pointer-events-none":""}`} style={{ padding: "6px" }}>
                        <DKIcon
                            src={ic_dollar}
                            className="cursor-hand"
                            style={{ height: "19px",transform:`scale(1.4)` }}
                            onClick={() => {
                                setIsBillable(!isBillable);
                            }}
                        />
                    </div>}
                    {entryMode === ENTRY_MODE.TIMER &&
                        <div className="fw-b  text-gray mr-l" style={{fontSize:45}}>
                            <CountUpTimer
                                timer={timer}
                                startTimer={startTimer}
                                stopTimer={stopTimer}
                                onStopTimer={(timeCount) => {

                                }}
                            />
                        </div>
                    }
                    {entryMode === ENTRY_MODE.MANUAL &&
                        <Fragment>
                            <div className="position-relative ">
                                <div
                                    className="border-radius-s p-v-s p-h-m cursor-pointer border-m text-white"
                                    style={{
                                        whiteSpace: "nowrap",
                                        // border: "1px solid #808080"
                                    }}
                                    onClick={() => {
                                        setShowDatePicker(true);
                                    }}
                                >
                                    <span className="fw-b ">
                                        {Utility.formatDate(entryDate, DATE_FORMAT.YYYYMMDD)}
                                    </span>
                                </div>
                                {showDatePicker && renderDatePicker()}
                            </div>
                            <div className="position-relative ">
                                <div
                                    className="border-radius-s p-v-s p-h-m cursor-pointer border-m text-white"
                                    style={{
                                        whiteSpace: "nowrap",
                                        // border: "1px solid #808080"
                                    }}
                                    onClick={() => {
                                        setShowStartTimePicker(true);
                                    }}
                                >
                                    <span className="fw-b ">
                                        {moment(startTime).format("hh:mm A")}
                                    </span>
                                </div>
                                {showStartTimePicker && renderTimePicker("Start Time", startTime, setStartTime, setShowStartTimePicker)}
                            </div>
                            <DKIcon src={ic_arrow_right_white} className="ic-s-2" />
                            <div className="position-relative ">
                                <div
                                    className="border-radius-s p-v-s p-h-m cursor-pointer border-m text-white"
                                    style={{
                                        whiteSpace: "nowrap",
                                        // border: "1px solid #808080"
                                    }}
                                    onClick={() => {
                                        setShowEndTimePicker(true);
                                    }}
                                >
                                    <span className="fw-b ">
                                        {moment(endTime).format("hh:mm A")}
                                    </span>
                                </div>
                                {showEndTimePicker && renderTimePicker("End Time", endTime, setEndTime, setShowEndTimePicker)}
                            </div>
                        </Fragment>
                    }
                    <DKButton
                        title={((entryMode === ENTRY_MODE.TIMER ) ? (startTimer ? "Stop" :"Start"):"Add")}
                        icon={getEntryModeButtonIcon()}
                        className={`cursor-hand mr-l fs-l fw-m ${entryMode === ENTRY_MODE.TIMER && startTimer ? "bg-white text-red border-m hover-red":"bg-white text-app border-m" }`}
                        onClick={() => {
                            if (entryMode === ENTRY_MODE.TIMER) {
                                const newState = {...formState};
                                
                                const fields = ['customer','project','task'];
                                let isValid = true;
                                fields.forEach(f=>{
                                    if(newState[f].validation && newState[f].validation.length >0 && newState[f].validation[0] === 'required' && Utility.isEmpty(newState[f].value)) {
                                        newState[f].invalid = true;
                                        isValid = false;
                                    } else {
                                        newState[f].invalid = false
                                    }
                                })
                                if(!isValid) {
                                    setFormState(newState);
                                    return
                                }
                                if (!selectedTask) {
                                    
                                    newState['task'].invalid = true
                                    setFormState(newState);
                                    showToast("Please select task", TOAST_TYPE.WARNING);
                                    return;
                                }
                                if (startTimer) {
                                    setStartTimer(false);
                                    setStopTimer(true);
                                    addTimesheetEntry("SUBMITTED");
                                    setTaskInputText("");
                                    setSelectedTask(null);
                                    setIsBillable(false);
                                    clearSelection();
                                } else {
                                    setStartTimer(true);
                                    setStopTimer(false);
                                    addTimesheetEntry("DRAFT");
                                }
                            } else {
                                const newState = {...formState};
                                
                                const fields = ['customer','project','task'];
                                let isValid = true;
                                fields.forEach(f=>{
                                    if(newState[f].validation && newState[f].validation.length >0 && newState[f].validation[0] === 'required' && Utility.isEmpty(newState[f].value)) {
                                        newState[f].invalid = true;
                                        isValid = false;
                                    } else {
                                        newState[f].invalid = false
                                    }
                                })
                                if(!isValid) {
                                    setFormState(newState);
                                    return
                                }
                                if (!selectedTask) {
                                    
                                    newState['task'].invalid = true
                                    setFormState(newState);
                                    showToast("Please select task", TOAST_TYPE.WARNING);
                                    return;
                                }
                                const sTime = new Date(startTime);
                                const fromDate = new Date(entryDate);
                                fromDate.setHours(sTime.getHours());
                                fromDate.setMinutes(sTime.getMinutes());

                                const eTime = new Date(endTime);
                                const toDate = new Date(entryDate);
                                toDate.setHours(eTime.getHours());
                                toDate.setMinutes(eTime.getMinutes());

                                addTimesheetEntry("DRAFT", fromDate, toDate);
                                setTaskInputText("");
                                setSelectedTask(null);
                                clearSelection()
                                setIsBillable(false);
                            }
                        }}
                    />
                    <div className={`column border-radius-l bg-light-app ${isTimerStart() ? "pointer-events-none":""}`} style={{ padding: "2px" }}>
                        <DKIcon
                            src={ic_play}
                            className="ic-s-2 cursor-hand "
                            style={{
                                opacity: entryMode === ENTRY_MODE.TIMER ? "1" : "0.4",
                                height:40
                            }}
                            onClick={() => {
                                setEntryMode(ENTRY_MODE.TIMER);
                                setDraftTimesheetEntry();
                            }}
                        />
                        <DKIcon
                            src={ic_add_circle}
                            className="ic-s-2 cursor-hand"
                            style={{
                                opacity: entryMode === ENTRY_MODE.MANUAL ? "1" : "0.4",
                                height:40
                            }}
                            onClick={() => {
                                setEntryMode(ENTRY_MODE.MANUAL);
                                setStartTime(new Date());
                                setEndTime(new Date());
                                setStartTimer(false);
                                setStopTimer(false);
                                setTimer(0);
                            }}
                        />
                    </div>
                </div>
            </div>
        );
    }

    const renderYearOptions = () => {
        return (
            <DKListPicker
                data={YEARS.map((year) => year)}
                className="position-absolute border-m shadow-m parent-width z-index-3"
                style={{ top: 28, left: 0, width: 150 }}
                onSelect={(index, value) => {
                    setYear(parseInt(value));
                    setShowYearOption(false);
                    renderCalendar(month, parseInt(value));
                }}
                onClose={() => {
                    setShowYearOption(false);
                }}
            />
        );
    };

    const renderCalendarViewOptions = () => {
        return (
            <DKListPicker
                data={CALENDAR_VIEW_OPTIONS}
                className="position-absolute border-m shadow-m parent-width z-index-3"
                onSelect={(index, value) => {
                    const calendarView = CALENDAR_VIEW[String(value).toUpperCase()];
                    if(calendarView == CALENDAR_VIEW.DAY) {
                        setDate( moment(reverseTimezoneOffset(moment().format('YYYY-MM-DD'))).format('D') )
                    }
                    setCalendarView(calendarView);
                }}
                onClose={() => {
                    setShowCalendarViewOption(false);
                }}
            />
        );
    };

    const renderCalendar = (month, year) => {
        const tableBody = calendarRef.current?.children[1] || {};
        tableBody.innerHTML = "";

        const firstDay = new Date(year, month).getDay();
        let date = 1;
        for (let i = 0; i < 6; i++) {
            const row = document.createElement("tr");
            for (let j = 0; j < 7; j++) {
                if (i === 0 && j < firstDay) {
                    const cell = document.createElement("td");
                    cell.style["width"] = "100px";
                    cell.style["height"] = "100px";
                    cell.appendChild(document.createTextNode(""));
                    row.appendChild(cell);
                } else if (date > Utility.daysInMonth(month, year)) {
                    break;
                } else {
                    const cell = document.createElement("td");
                    cell.style["width"] = "100px";
                    cell.style["height"] = "120px";
                    cell.style["vertical-align"] = "baseline";
                    cell.classList.add("cursor-hand");

                    if (date === today.getDate() && month === today.getMonth() && year === today.getFullYear()) {
                        cell.classList.add("bg-gray1");
                    }

                    const cellText = document.createElement("div");
                    cellText.innerHTML = date;
                    cellText.style["padding"] = "7px";
                    cellText.style["text-align"] = "left";
                    cell.appendChild(cellText);

                    cell.addEventListener("click", (e) => {
                        e.stopPropagation();

                        const entryDate = new Date(year, month, cellText.innerHTML);
                        const today = new Date();

                        const fromDate = new Date(entryDate);
                        fromDate.setHours(today.getHours());
                        fromDate.setMinutes(today.getMinutes());

                        const toDate = new Date(entryDate);
                        toDate.setHours(today.getHours());
                        toDate.setMinutes(today.getMinutes());
                        if(!isTimerStart()) {
                            showAddTimesheetEntryPopup({
                                entryDate: entryDate,
                                fromDate: fromDate,
                                toDate: toDate,
                                onSave: () => {
                                    getTimesheetEntries();
                                }
                            });
                        } else {
                            showToast("Please stop timer to add new Timesheet entry")
                        }
                        
                    }, false);

                    if (Array.isArray(timesheetEntries)) {
                        const entries = getDateEntries(date, month, year);
                        if (Array.isArray(entries)) {
                            entries.sort((a, b) => a.fromDate < b.fromDate);
                            if (entries.length < 4) {
                                showEntryOnCalendar(entries, cell);
                            } else {
                                showEntryOnCalendar(entries.slice(0, 3), cell);
                                const moreEntries = document.createElement("div");
                                moreEntries.style["display"] = "flex";
                                moreEntries.style["align-items"] = "center";
                                moreEntries.style["padding-top"] = "2px";
                                moreEntries.style["padding-left"] = "12px";
                                moreEntries.style["padding-right"] = "3px";
                                moreEntries.style["font-weight"] = "600";

                                moreEntries.innerHTML = `+${entries.length - 3} more`;
                                moreEntries.addEventListener("click", (e) => {
                                    e.stopPropagation();

                                    showMoreEntriesPopup({
                                        entryDate: new Date(year, month, cellText.innerHTML),
                                        entries: entries,
                                        onShowEntry: (entryData) => {
                                            if(isTimerStart() && Utility.isEmpty(entryData?.toDate)) {
                                                showToast("Please stop timer to edit new Timesheet entry")
                                                return
                                            }
                                            showAddTimesheetEntryPopup({
                                                isEdit: true,
                                                entryData: entryData,
                                                onSave: () => {
                                                    getTimesheetEntries();
                                                }
                                            });
                                        }
                                    });
                                }, false);
                                cell.appendChild(moreEntries);
                            }
                        }
                    }

                    row.appendChild(cell);
                    date++;
                }
            }

            tableBody?.appendChild?.(row);
        }
        if (calendarRef.current) {
        }
    };

    const renderActionButtonRow = () => {
        return (
            <div className="row parent-width justify-content-between justify-content-end-mobile" style={{ marginBottom: pageView === PAGE_VIEW.CALENDAR ? "18px" : "-8px" }}>
                {/* {pageView === PAGE_VIEW.LIST &&
                    <div className="row">
                        <DKLabel text={"Timesheet"} className="fw-b fs-l" />
                        {refreshingView && (
                            <DKSpinner className="ml-r" />
                        )}
                    </div>
                } */}
                {pageView === PAGE_VIEW.CALENDAR && (
                    <div className="row parent-width display-only-web" style={{ width: "360px" }}>
                        <div className="column mr-m cursor-hand"
                            onClick={() => {
                                if (calendarView === CALENDAR_VIEW.DAY || calendarView === CALENDAR_VIEW.WEEK) {
                                    setPrevButtonTapped(true);
                                    setNextButtonTapped(false);
                                    setTodayTapped(false);
                                } else {
                                    prevMonth();
                                }
                            }}
                        >
                            <DKIcon src={DKIcons.ic_arrow_left} className="mr-s" style={{ height: "12px" }} />
                        </div>
                        <div className="column cursor-hand mr-l"
                            onClick={() => {
                                if (calendarView === CALENDAR_VIEW.DAY || calendarView === CALENDAR_VIEW.WEEK) {
                                    setNextButtonTapped(true);
                                    setPrevButtonTapped(false);
                                    setTodayTapped(false);
                                } else {
                                    nextMonth();
                                }
                            }}
                        >
                            <DKIcon src={DKIcons.ic_arrow_right} style={{ height: "12px" }} />
                        </div>
                        {calendarView === CALENDAR_VIEW.DAY && <div className=" mr-s">
                            <DKLabel text={date}></DKLabel>
                        </div>}
                        <div className="row width-auto" style={{ whiteSpace: 'nowrap' }}>
                            <DKLabel text={FULL_MONTHS[month]} className="mr-xs" />
                            <div className="d-flex position-relative cursor-hand" onClick={() => { setShowYearOption(!showYearOption) }}>
                                <DKLabel text={year} className="mr-s" />
                                <DKIcon src={DKIcons.ic_arrow_down} style={{ height: "12px", paddingTop: "3px" }} />
                                {showYearOption && renderYearOptions()}
                            </div>
                        </div>
                        <DKButton
                            className="bg-white ml-r border-m"
                            title="Today"
                            onClick={() => {
                                setDate(today.getDate())
                                setMonth(today.getMonth());
                                setYear(today.getFullYear());

                                if (calendarView === CALENDAR_VIEW.DAY || calendarView === CALENDAR_VIEW.WEEK) {
                                    setTodayTapped(true);
                                    setPrevButtonTapped(false);
                                    setNextButtonTapped(false);
                                } else {
                                    renderCalendar(today.getMonth(), today.getFullYear());
                                }
                            }}
                        />
                        <div className="row width-auto ml-m justify-content-between p-h-s p-v-xs border-m bg-white border-radius-m position-relative cursor-hand"
                            style={{ padding: "8px 10px" }}
                            onClick={() => {
                                setShowCalendarViewOption(!showCalendarViewOption);
                            }}
                        >
                            <DKLabel className="unselectable" text={calendarView} />
                            <DKIcon src={DKIcons.ic_arrow_down2} className="ic-s unselectable ml-xs" style={{ height: "15px" }} />
                            {showCalendarViewOption && renderCalendarViewOptions()}
                        </div>
                        {refreshingView && (
                            <DKSpinner className="ml-r" />
                        )}
                    </div>
                )}
                {pageView === PAGE_VIEW.CALENDAR &&<div className="row row-responsive" style={{ width: "auto", gap: 8 }}>
                    <DKButton
                        title="+ Timesheet Entry"
                        className={`text-white ${isTimerStart() ? "bg-gray cursor-auto":"bg-button "}`}
                        onClick={() => {
                            if(!isTimerStart()) {
                                showAddTimesheetEntryPopup({
                                    onSave: () => {
                                        getTimesheetEntries();
                                    }
                                });
                            }
                            
                        }}
                    />
                    <div className="row-reverse border-m border-radius-m" style={{ width: "auto", overflow: "hidden" }}>
                        <div className={`column cursor-hand p-s ${pageView === PAGE_VIEW.LIST ? "bg-button" : "bg-white"}`} onClick={() => {getTimesheetEntries();setPageView(PAGE_VIEW.LIST)}}>
                            <DKIcon className="ic-s" src={`${pageView === PAGE_VIEW.LIST ? ic_cells_white : ic_cells}`} />
                        </div>
                        <div className={`column cursor-hand p-s ${pageView === PAGE_VIEW.CALENDAR ? "bg-button" : "bg-white"}`} onClick={() => {getTimesheetEntries();setPageView(PAGE_VIEW.CALENDAR)}}>
                            <DKIcon className="ic-s" src={`${pageView === PAGE_VIEW.CALENDAR ? DKIcons.white.ic_calendar : ic_calendar}`} />
                        </div>
                    </div>
                </div>}
            </div>
        );
    }
    const deleteEntry=(data)=>{
        
        if (data.status === "APPROVED" || data.status === "REJECTED" || data.status === TIMESHEET_CONSTANTS.SUBMITTED) {
            showAlert("Info","Not allowed to delete submitted/approved/rejected timesheet entry.");
            return;
        }
        if(isTimerStart() && Utility.isEmpty(data?.toDate)) {
            showToast("Please stop timer to delete draft Timesheet entry")
            return
        }
        showAlert("Delete","Are you sure want to delete task ?",[
            {
                title: t("YES"),
                className: "bg-app text-white mr-xl",
                onClick: () => {
                    
                    onRowDelete({
                        rowData:{timesheetEntry:data}
                    });
                }
            },
            {
                title: t("NO"),
                className: "bg-gray1 border-m"
            }
        ])
    }
    const onSubmit=(data)=>{
        let payload
        if (data?.rowData) {
            if (data.rowData.timesheetEntry.status === "APPROVED" ) {
                showAlert("Info","Not allowed to submit admin approved timesheet entry.");
                return;
            }
            if(isTimerStart() && Utility.isEmpty(data.rowData?.timesheetEntry?.toDate)) {
                showToast("Please stop timer to submit draft Timesheet entry")
                return
            }
            payload = {
                ids: [`${data.rowData.timesheetEntry.id}`]
            };

            TimesheetService.submitTimesheetEntry(payload).then(() => {
                showToast("Timesheets Submitted", TOAST_TYPE.SUCCESS);
                
                getTimesheetEntries()
                refreshView()
            })  
        }
    }
    return (
        <div className="parent-width parent-height">
            {renderTimesheetEntryRow()}
            {renderActionButtonRow()}
            <div className={`parent-width ${pageView !== PAGE_VIEW.CALENDAR ? "parent-height":""} flex-1`}>
                {pageView === PAGE_VIEW.CALENDAR &&
                    <div className="row parent-width align-self-start">
                        {calendarView === CALENDAR_VIEW.DAY &&
                            <DayViewCalender
                                day={WEEK_DAYS[new Date().getDay()]}
                                monthAndYear={TimesheetUtils.getMonthAndYearString(month, year)}
                                onAddTask={(e, date, hour) => {
                                    const entryDate = new Date(date);

                                    const fromDate = new Date(date);
                                    fromDate.setHours(hour.format, 0, 0, 0);

                                    const toDate = new Date(date);
                                    toDate.setHours(parseInt(hour.format) + 1, 0, 0, 0);
                                    if(!isTimerStart()) {
                                        showAddTimesheetEntryPopup({
                                            entryDate: entryDate,
                                            fromDate: fromDate,
                                            toDate: toDate,
                                            onSave: () => {
                                                getTimesheetEntries();
                                            }
                                        });
                                    } else {
                                        showToast("Please stop timer to add new Timesheet entry")
                                    }
                                }}
                                tasks={timesheetEntries}
                                taskRenderer={TimesheetUtils.dayAndWeekTaskRenderer}
                                onShowTask={(entryData) => {
                                    if(isTimerStart() && Utility.isEmpty(entryData?.toDate)) {
                                        showToast("Please stop timer to edit new Timesheet entry")
                                        return
                                    }
                                    if(entryData.status === ENTRY_STATUS.REJECTED && !TenantService.get(TENANT.IS_ADMIN)){
                                        return;
                                    }
                                    showAddTimesheetEntryPopup({
                                        isEdit: true,
                                        entryData: entryData,
                                        onSave: () => {
                                            getTimesheetEntries();
                                        }
                                    });
                                }}
                                prevButtonTapped={prevButtonTapped}
                                nextButtonTapped={nextButtonTapped}
                                todayTapped={todayTapped}
                                dateToShow={reverseTimezoneOffset(moment().format('YYYY-MM-DD'))}
                                prevDay={(startDate) => {
                                    setDate(startDate.getDate())
                                    setMonth(startDate.getMonth());
                                    setYear(startDate.getFullYear());
                                    setPrevButtonTapped(false);
                                    setNextButtonTapped(false);
                                    setTodayTapped(false);
                                }}
                                nextDay={(endDate) => {
                                    setDate(endDate.getDate())
                                    setMonth(endDate.getMonth());
                                    setYear(endDate.getFullYear());
                                    setPrevButtonTapped(false);
                                    setNextButtonTapped(false);
                                    setTodayTapped(false);
                                }}
                                deleteEntry={(data)=>deleteEntry(data)}
                                onSubmit={onSubmit}
                            />
                        }
                        {calendarView === CALENDAR_VIEW.WEEK &&
                            <WeekViewCalendar
                                day={WEEK_DAYS[new Date().getDay()]}
                                monthAndYear={TimesheetUtils.getMonthAndYearString(month, year)}
                                onAddTask={(e, date, hour) => {
                                    const entryDate = new Date(date);

                                    const fromDate = new Date(date);
                                    fromDate.setHours(hour.format, 0, 0, 0);

                                    const toDate = new Date(date);
                                    toDate.setHours(parseInt(hour.format) + 1, 0, 0, 0);
                                    if(!isTimerStart()) {
                                        showAddTimesheetEntryPopup({
                                            entryDate: entryDate,
                                            fromDate: fromDate,
                                            toDate: toDate,
                                            onSave: () => {
                                                getTimesheetEntries();
                                            }
                                        });
                                    } else {
                                        showToast("Please stop timer to add new Timesheet entry")
                                    }
                                    
                                }}
                                tasks={timesheetEntries}
                                taskRenderer={TimesheetUtils.dayAndWeekTaskRenderer}
                                onShowTask={(entryData) => {
                                    if(isTimerStart() && Utility.isEmpty(entryData?.toDate)) {
                                        showToast("Please stop timer to edit new Timesheet entry")
                                        return
                                    }
                                    if(entryData.status === ENTRY_STATUS.REJECTED && !TenantService.get(TENANT.IS_ADMIN)){
                                        return;
                                    }
                                    showAddTimesheetEntryPopup({
                                        isEdit: true,
                                        entryData: entryData,
                                        onSave: () => {
                                            getTimesheetEntries();
                                        }
                                    });
                                }}
                                prevButtonTapped={prevButtonTapped}
                                nextButtonTapped={nextButtonTapped}
                                todayTapped={todayTapped}
                                weekStartDate={(startDate) => {
                                    setMonth(startDate.getMonth());
                                    setYear(startDate.getFullYear());
                                    setPrevButtonTapped(false);
                                    setNextButtonTapped(false);
                                    setTodayTapped(false);
                                }}
                                weekEndDate={(endDate) => {
                                    setMonth(endDate.getMonth());
                                    setYear(endDate.getFullYear());
                                    setPrevButtonTapped(false);
                                    setNextButtonTapped(false);
                                    setTodayTapped(false);
                                }}
                            />
                        }
                        {calendarView === CALENDAR_VIEW.MONTH &&
                            <Fragment>
                                <div className="parent-width column border-box bg-white border-radius-s show-scroll-bar align-self-start shadow-s display-only-web calendar-view" id="calendar-wrapper">
                                    <table className="table parent-width p-m pb-l" id="calendar" ref={calendarRef}>
                                        <thead className="parent-width">
                                            <tr className="parent-width pt-l">
                                                {WEEK_DAYS.map((day) => (
                                                    <th className="pb-r text-gray" style={{ fontWeight: "500" }} key={`day-${day}`}>
                                                        {day}
                                                    </th>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody id="calendar-body"></tbody>
                                    </table>
                                </div>
                            </Fragment>
                        }
                    </div>
                }
                {pageView === PAGE_VIEW.LIST &&
                    <div className="parent-width parent-height pb-l">
                        <DataGridHolderPayroll
                        tableName={TABLES.PEOPLE_TIMESHEET_ENTRY}
                        displayTableName={TABLE_DISPLAY_NAME[TABLES.PEOPLE_TIMESHEET_ENTRY]}
                        allowBulkOperation={true}
                        allowColumnEdit={false}
                        allowColumnDelete={false}
                        allowColumnShift={false}
                        allowSearch={false}
                        allowFilter={false}
                        allowColumnAdd={false}
                        allowRowAdd={false}
                        allowColumnSort={false}
                        refresh={false}
                        allowDataExport={false}
                        allowRowEdit={true}
                        showContextEdit={false}
                        contextMenu={true}
                        isMenuVisible={true}
                        showContextMenu={true}
                        isActionEnabled={true}
                        gridData={timesheetEntryData}
                        currentPage={currentPage}
                        totalPageCount={totalPageCount}
                        onRowEdit={(data) => {
                            onRowEdit(data);
                        }}
                        onRowDelete={(data) => {
                            onRowDelete(data);
                        }}
                        onPaginationClick={(requestedPageNumber) => {
                            setCurrentPage(requestedPageNumber);

                            TimesheetService.TIMESHEET_API_CONFIG.currentPage = requestedPageNumber;
                            refreshView();
                        }}
                        addButtonConfig={[
                        {
                            title:"",
                            className:"bg-app border-radius-right-m",
                            icon:DKIcons.white.ic_calendar,
                            onClick:()=>{
                             getTimesheetEntries();setPageView(PAGE_VIEW.LIST)
                            } 
                         },
                        {
                           title:"",
                           className:"bg-white  border-radius-left-m border-m",
                           icon:DKIcons.ic_calendar,
                           onClick:()=>{
                            getTimesheetEntries();setPageView(PAGE_VIEW.CALENDAR)
                           } 
                        },
                        {
                            title: "+ Timesheet Entry",
                            className: `text-white mr-s ${isTimerStart() ? "bg-gray cursor-auto":"bg-button"}`,
                            onClick:() => {
                                if(!isTimerStart()) {
                                    showAddTimesheetEntryPopup({
                                        onSave: () => {
                                            getTimesheetEntries();
                                        }
                                    });
                                }
                                
                            }
                        }
                        ]}
                        onSubmit={onSubmit}
                        addMenuButton={[                    
                            {
                                title: t("Submit"),
                                className: "bg-app text-white mr-s ",
                                hide: false,                        
                                onClick: (data, value) => {  
                                    let isAllow = true;
                                    let isApprovedRejected = true
                                    let ids = []
                                    data.forEach(d => {
                                        if (d.timesheetEntry.status === "APPROVED" ) {
                                            isApprovedRejected = false
                                        }
                                        if (isTimerStart() && Utility.isEmpty(d?.timesheetEntry?.toDate)) {
                                            showToast("Please stop timer to delete draft Timesheet entry")
                                            isAllow = false
                                        }
                                        ids.push(d?.timesheetEntry?.id)
                                    })

                                    if(!isAllow || !isApprovedRejected) {
                                        
                                        refreshView();
                                        getTimesheetEntries()
                                        if(!isApprovedRejected) {
                                            showAlert("Info","Timesheet which already Approved not allow to submit.")
                                        }
                                        return
                                    }
                                    const payload = {
                                        ids : ids
                                    }
                                    TimesheetService.submitTimesheetEntry(payload).then(() => {
                                    showToast("Timesheets Submitted", TOAST_TYPE.SUCCESS);
                                    
                                    getTimesheetEntries()
                                    refreshView()
                                    })                           
                                },
                            },
                            {
                                title: t("Delete"),
                                className: "bg-red text-white mr-s ",
                                hide: false,                        
                                onClick: (data, value) => {  
                                    onRowDelete(data)                                                   
                                                              
                                },
                            },
                        ]
                        }
                        onColumnShift={(data)=> refreshView()}
                    />
                    </div>
                }
            </div>
        </div>
    );
}

export default TimesheetEntry;
